let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kh9kE")).then(() => parcelRequire('5Qxpc'));